import { differenceInMinutes, isValid } from 'date-fns';
import { useNow } from './use-now';

export function useMinutesAgo(dateStr: string | undefined): string {
    const now = useNow();
    if (!dateStr) {
        return '';
    }
    const date = new Date(dateStr);
    if (!isValid(date)) {
        return '';
    }
    const minutes = Math.abs(differenceInMinutes(date, now));
    return minutes > 1 ? `${minutes} minutes ago` : 'just now';
}
